export class ProductSearch {
    id: string;
    name: string;
    skip: number = 0;
    limit: number = 10;
    totalItems: number = 0;
    allItems: Boolean = false;
}



// WEBPACK FOOTER //
// ./src/app/models/ProductSearch.model.ts